var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('calendar',{attrs:{"loading":_vm.loading,"report":_vm.report},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('RentalRevenue',{attrs:{"report":_vm.report}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }